import React, { useMemo, useState } from "react"

import icAdd from "@/assest/ic_add.png"
import icDelete from "@/assest/ic_delete.png"
import defaultAvatar from "@/assest/default_avatar.png"
import { User, userDisplayName } from "@/models/biz_model"
import { useAppDispatch, useAppSelector } from "@/store"
import {
  LoginApiVersion,
  ViewType,
  changeUser,
  changeViewType,
  deleteUser,
  gotoAddNewUser,
  selectLoginUsers,
  setLoginApiVersion,
} from "@/stores/login_slice"
import { AppDialog } from "@/widgets/AppDialog"
import { Box, Container, Flex, Image, Text, Tooltip } from "@chakra-ui/react"
import { CloseIcon } from "@chakra-ui/icons"
import { ConnectionUseCase } from "@/usecases/connection"
import { AuthCache } from "@/utils/storage"
import { setAuth } from "@/stores/auth_slice"

const ChangeUserCom: React.FC = () => {
  // 所有登录过的用户列表
  const users = useAppSelector(selectLoginUsers)
  const dispatch = useAppDispatch()

  // 点击取消
  const handleCancel = () => {
    dispatch(changeViewType(ViewType.login))
    dispatch(setLoginApiVersion(LoginApiVersion.newApi))
  }

  // 添加新用户
  const addUser = () => {
    dispatch(gotoAddNewUser())
  }

  return (
    <Flex
      direction="column"
      width="100vw"
      height="100vh"
      justify="space-between"
      align="center"
      fontSize={"15px"}
      color="white"
    >
      <Flex
        paddingTop={"28vh"}
        justifyContent="center"
        flexWrap="wrap"
        gap="20px"
        maxWidth="80vw"
      >
        {/* 用户列表 */}
        {users.map((u) => {
          return <UserAvatar key={u.account} user={u} />
        })}
        {/* 添加用户按钮 */}
        <Flex
          direction="column"
          width="80px"
          height="80px"
          align="center"
          cursor="pointer"
          onClick={addUser}
        >
          <img src={icAdd} alt="" />
          <Text fontSize="12px" marginTop="8px">
            添加账户
          </Text>
        </Flex>
      </Flex>
      {/* 底部取消 */}
      <Flex direction="column" align="center" marginBottom="16px">
        <CloseIcon
          width="32px"
          height="32px"
          padding="10px"
          cursor={"pointer"}
          borderRadius={"50%"}
          color="#979797"
          background="rgba(0, 0, 0, 0.56)"
          onClick={handleCancel}
        />
        <Text color="#e8e8e8" fontSize="12px" marginTop="4px">
          取消
        </Text>
      </Flex>
    </Flex>
  )
}

interface UserAvatarProps {
  user: User
  [key: string]: any
}
const UserAvatar: React.FC<UserAvatarProps> = ({ user, ...props }) => {
  const dispatch = useAppDispatch()
  const [isShowDeleteBtn, setIsShowDeleteBtn] = useState(false)
  const [isShowDeleteDialog, setIsShowDeleteDialog] = useState(false)

  // 选择用户
  const handleChangeUser = () => {
    // 切换用户：先断开旧信令；恢复新用户 auth 到 Redux，使切换后登录页的 HTTP 请求
    // 用新用户 token；切到新用户后立即用新用户缓存凭证重连信令，对齐 android
    // onSelectUser -> reconnectSignaling，使切换后无需重新登录也能收到远程协助。
    void ConnectionUseCase.disconnectSignaling()
    const auth = AuthCache.getAuth(user.account)
    if (auth !== null) {
      dispatch(setAuth(auth))
    }
    dispatch(changeUser(user))
    void ConnectionUseCase.connectSignaling()
  }
  // 弹出删除用户确认弹窗
  const showDeleteUserDialog = (e: React.MouseEvent) => {
    e.stopPropagation()
    setIsShowDeleteDialog(true)
  }
  // 确认删除用户
  const confirmDeleteUser = () => {
    setIsShowDeleteDialog(false)
    // 删除当前用户时断开信令连接（对齐 android deleteUser disconnectSignaling）
    void ConnectionUseCase.disconnectSignaling()
    dispatch(deleteUser(user))
  }
  const displayName = useMemo(() => userDisplayName(user), [user])

  return (
    <>
      <Flex {...props} direction="column" align="center">
        <Box
          textAlign="center"
          width="80px"
          height="80px"
          borderRadius="50%"
          position="relative"
          overflow="hidden"
          cursor="pointer"
          onMouseEnter={() => {
            setIsShowDeleteBtn(true)
          }}
          onMouseLeave={() => {
            setIsShowDeleteBtn(false)
          }}
          onClick={handleChangeUser}
        >
          <Image
            src={user.avatar || defaultAvatar}
            alt=""
            width="100%"
            height="100%"
          />
          {/* 删除按钮 */}
          {isShowDeleteBtn && (
            <Flex
              position="absolute"
              bottom="0"
              left="0"
              width="100%"
              height="24px"
              background="rgba(0, 0, 0, 0.7)"
              justifyContent="center"
              alignItems="center"
              onClick={showDeleteUserDialog}
            >
              <Image
                src={icDelete}
                width="18px"
                height="18px"
                padding="2px"
                alt="Delete"
              />
            </Flex>
          )}
        </Box>
        <Tooltip
          hasArrow
          label={displayName}
          bg="white"
          color="black"
          fontSize="12px"
          placement="bottom"
        >
          <Container
            marginTop="8px"
            fontSize="12px"
            color="white"
            width="80px"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {displayName}
          </Container>
        </Tooltip>
      </Flex>
      {/* 删除用户确认弹窗 */}
      <AppDialog
        title={`确认删除"${displayName}" ？`}
        isOpen={isShowDeleteDialog}
        onConfirm={confirmDeleteUser}
        onCancel={() => {
          setIsShowDeleteDialog(false)
        }}
      />
    </>
  )
}

export default ChangeUserCom
